// extracted by mini-css-extract-plugin
var _1 = "loader-module_laoderWrap_gWVjO";
export { _1 as "laoderWrap" }
